export class ReportGranularity {
    PERFORMANCE: number;
    LOAD: number;

    constructor(json) {
        this.PERFORMANCE = json.PERFORMANCE;
        this.LOAD = json.LOAD;
    }
}
